// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrapper from './App';
import reportWebVitals from './reportWebVitals';
// Impor fungsi pendaftaran baru kita
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);

// Panggil fungsi pendaftaran dengan konfigurasi kita
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Ini akan berjalan ketika ada SW baru yang menunggu
    // Kita kirim event kustom yang akan ditangkap oleh App.js
    const event = new CustomEvent('swUpdate', { detail: registration });
    window.dispatchEvent(event);
  },
});

reportWebVitals();